import { all } from "redux-saga/effects";
import authSaga from "./auth/authSaga";
import posSaga from "./pos/posSaga";

export default function* rootSaga() {
  yield all([authSaga(), posSaga()]);
}
